import qs from "qs";
import Swal from "sweetalert2";
import { createRouter, createWebHistory } from "vue-router";
import store from "../store";
import admin from "./admin";
import alerts from "./alerts";
import base from "./base";
import myProfile from "./myProfile";
import patients from "./patients";
import providers from "./providers";
import staticPages from "./static";

const routes = [
  ...base,
  ...staticPages,
  ...patients,
  ...admin,
  ...providers,
  ...myProfile,
  ...alerts,
];

const router = createRouter({
  history: createWebHistory(),
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
  parseQuery(query) {
    return qs.parse((query || "").replace(/^\?+/, ""));
  },
  stringifyQuery(query) {
    const result = qs.stringify(query, { encode: false });

    // Vue Router expects this without a leading '?'.
    return result || "";
  },
});

let preventNavigationMessage = "";

export function setNavigationBlock(message = "") {
  preventNavigationMessage = message;
}

function handleBeforeRouting(to, from, next) {
  let title = store.state["appConfig"].title || "C3 CRM";

  if (to.meta.title) {
    title = title + " | " + to.meta.title;
  }
  document.title = title;

  if (to.matched.some((record) => record.meta.auth)) {
    if (!localStorage.getItem("ARSS_TOKEN")) {
      next({ name: "login" });
    } else if (
      localStorage.getItem("ARSS_TOKEN") &&
      !localStorage.getItem("USER_TYPE") &&
      !store.state["auth"].authenticated
    ) {
      localStorage.removeItem("ARSS_TOKEN");
      localStorage.removeItem("USER_TYPE");
      localStorage.removeItem("C3_LOGIN");
      next({ name: "login" });
    } else {
      if (to.matched.some((record) => record.meta.admin)) {
        if (
          to.matched.some((record) => record.meta.noManager) &&
          localStorage.getItem("USER_TYPE") === "Manager"
        ) {
          next({ name: "dashboard" });
        } else if (
          localStorage.getItem("USER_TYPE") !== "Admin" &&
          localStorage.getItem("USER_TYPE") !== "Manager"
        ) {
          next({ name: "dashboard" });
        } else {
          next();
        }
      } else if (to.matched.some((record) => record.meta.provider)) {
        if (localStorage.getItem("USER_TYPE") !== "Provider") {
          next({ name: "dashboard" });
        } else {
          next();
        }
      } else if (
        to.matched.some((record) => record.meta.noClient) &&
        localStorage.getItem("USER_TYPE") === "Patient"
      ) {
        next({ name: "dashboard" });
      } else {
        next();
      }
    }
  } else if (to.matched.some((record) => record.meta.guest)) {
    if (localStorage.getItem("ARSS_TOKEN")) {
      next({ name: "dashboard" });
    } else {
      next();
    }
  } else {
    next(); // make sure to always call next()!
  }
}
router.beforeEach((to, from, next) => {
  if (preventNavigationMessage) {
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: "btn btn-black ml-4",
        cancelButton: "btn btn-danger",
      },
      buttonsStyling: false,
    });
    return swalWithBootstrapButtons
      .fire({
        title: "Warning",
        text: preventNavigationMessage,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, leave",
        cancelButtonText: "No, cancel",
        reverseButtons: true,
      })
      .then(async (result) => {
        if (result.isConfirmed) {
          setNavigationBlock(); // allow navigation next time
          handleBeforeRouting(to, from, next);
        } else {
          return; // prevent navigation
        }
      });
  }
  handleBeforeRouting(to, from, next);
});

export default router;
